import React from "react";
import Fixedbg from "@/components/UserView/FixedBaground/Fixedbg";
import Header from '@/components/UserView/Header/header';
import Header2 from "@/components/UserView/Header2/header2";
import { Link } from "react-router-dom";
import '@/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Footer from "../Footer/footer";
import { Container,Row,Breadcrumb , ListGroup} from "react-bootstrap";


const Notification = () =>{

    const token = localStorage.getItem("token");

    function menu(){
    if(token === undefined || token === null){
        return(
            <>
            <Header/>
            </>
        )
    }
    else{
        return(
            <>
            <Header2/>
            </>
        )
    }
}

  return(
<>
{menu()}
      <Container className="notification pb-5 min-height-g">
        <Breadcrumb className="pt-5 pb-4">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active> Notifications</Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <ListGroup>
                <ListGroup.Item className="mb-3 py-4 px-4 border-0 rounded-10 shadow-css d-flex un-read">
                    <span className="noti-icon"></span>
                    <span className="noti-text py-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco labori.
                    <span className="noti-time">5 mins ago</span>
                    </span>
                </ListGroup.Item>
                <ListGroup.Item className="mb-3 py-4 px-4 border-0 rounded-10 shadow-css d-flex">
                    <span className="noti-icon"></span>
                    <span className="noti-text py-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco labori.
                    <span className="noti-time">5 mins ago</span>
                    </span>
                </ListGroup.Item>
          </ListGroup>
        </Row>
      </Container>
      <Footer />
</>
  )}
export default Notification;